import { DateTime } from '@ksyos/date-time';
import type { IOorkV1ProcedureCustomControlData } from '@common/interfaces/ophthalmology/OorkAndOcrk/oorkV1ProcedureCustomControlData';

export function oorkV1ProcedureInitializeCustomControlData(): IOorkV1ProcedureCustomControlData {
    return {
        zorgdomein_code: null,
        email_betrokkene: null,
        mobileNumber: null,
        homePhoneNumber: null,
        bsn_betrokkene: null,
        inspection_rights_consented: null,
        share_medical_info_consented: null,
        reden_van_keuring: null,
        overige_reden_van_keuring: null,
        overige_anamnese: null,
        betrokkene_bezit_rijbewijs: null,
        legitimatie_betrokkene_gezien: null,
        categorie_rijbewijs: null,

        datum_onderzoek: DateTime.now().format('YYYY-MM-DD'),
        eigen_correctie: {
            bril: false,
            contactlenzen_overdag: false,
            nachtlenzen: false,
            geen_eigen_correctie: false,
        },
        visus_zonder_correctie_od: null,
        visus_zonder_correctie_os: null,
        visus_zonder_correctie_ods: null,
        visus_eigen_correctie_od: null,
        visus_eigen_correctie_os: null,
        visus_eigen_correctie_ods: null,
        visus_optimale_correctie_od: null,
        visus_optimale_correctie_os: null,
        visus_optimale_correctie_ods: null,
        refractie_optimale_correctie: null,
        aanwijzingen_defecten_gezichtsveld: null,
        beschrijving_gezichtsvelddefecten: null,
        sprake_van_diplopie: null,
        betrokkene_gebruikt_hulpmiddel: null,
        diplopie_is_hinderlijk: null,
        toelichting_diplopie: null,
        gestoorde_donkeradaptie: null,
        toelichting_donkeradaptie: null,
        files: [],
        consult: {
            selectedDiagnosticReportProviderOrganizationId: null,
            selectedDiagnosticReportProviderPractitionerId: null,
            toelichting: null,
            question: 'Graag uw verdere verwerking',
        },
    };
}
